const EmptyDashboard = (props) => {
    return (
        <div className="h-full w-full flex align-items-center justify-content-center  font-bold text-base">
            <span>{props.tipo}</span>
        </div>
    );
}

export default EmptyDashboard;